import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	generateQRCodeContent: {
		maxWidth: 275,
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: 6,
		padding: theme.spacing(4, 2)
	},
	generateQRCodeText: {
		fontSize: 16,
		lineHeight: "24px"
	},
	arrowDownIcon: {
		fontSize: 72
	},
	qrCodeGenerationProgress: {
		height: 44,
		width: "100%",
		borderRadius: theme.spacing(0.5),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50])
	},
	iconButtonLink: {
		color: colors.gray[700]
	},
	queueLabel: {
		fontWeight: 700
	},
	validationButton: {
		padding: theme.spacing(1.25, 4),
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.red[400])
		}
	},
	queueCleaningDescription: {
		fontWeight: 400,
		fontSize: 14
	},
	queueCleaningWarningDescriptionContainer: {
		paddingLeft: theme.spacing(3.5)
	}
}))

export default useStyles
